// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3Yv3I","Open":"SideDrawer_Open__3wZQj","Close":"SideDrawer_Close__3Plbp"};